import {
  createApiFactory,
  createPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { docsOwnershipApiRef, techDocsMetadataApiRef } from './api';
import { DocsOwnershipClient } from '@appfolio/backstage-plugin-docs-ownership-common';
import { TechDocsMetadataClient } from '@appfolio/backstage-plugin-techdocs-common';

export const techdocsExtensionPlugin = createPlugin({
  id: 'appfolio-techdocs',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: docsOwnershipApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new DocsOwnershipClient({ discoveryApi, fetchApi }),
    }),
    createApiFactory({
      api: techDocsMetadataApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new TechDocsMetadataClient({ discoveryApi, fetchApi }),
    }),
  ],
});
